import firebase from "firebase";
import {deserialize, serialize} from "serializr";
import {BranchModel} from "@/modules/mconfigs/models/BranchModel";

export default {
  namespaced: true,
  state: {
    mReadonly: false,
    mValues: []
  },
  getters: {
    getValue: (state) => (uid) => {
      return state.mValues.find(v => v.uid === uid) || null;
    },
    getValues: (state) => {
      return state.mValues;
    }
  },
  mutations: {
    setValues(state, values) {
      state.mValues = values;
    },
    setReadonly(state, readonly) {
      state.mReadonly = readonly;
    },
    addValues(state, values) {
      let keys = values.map(v => v.uid);

      state.mValues = state.mValues.filter(v => {
        let index = keys.findIndex(key => {
          return key.equal(v.uid);
        });

        return index < 0;
      }).concat(values);
    },
    updateValues(state, values) {
      values.forEach(value => {
        let index = state.mValues.findIndex(v => {
          return v.uid === value.uid;
        });

        if (index >= 0) {
          state.mValues.splice(index, 1, value);
        } else {
          state.mValues.push(value);
        }
      });
    },
    updateValue(state, value) {
      value.changed = true;

      state.mValues.forEach(v => {
        v.changed = false;
      });

      let index = state.mValues.findIndex(v => {
        return v.uid === value.uid;
      });

      if (index >= 0) {
        state.mValues.splice(index, 1, value);
      } else {
        state.mValues.push(value);
      }
    },
    removeValue(state, uid) {
      let index = state.mValues.findIndex(v => v.uid === uid);

      if (index >= 0) {
        state.mValues.splice(index, 1);
      }
    },
  },
  actions: {
    init({commit}) {
      console.info('branch-store initialized.');
      let db = firebase.database();

      return db.ref("/branches")
        .once("value")
        .then((snapshot) => {
          let data = Object.values(snapshot.val() || {});
          let values = data.map(v => deserialize(BranchModel, v));
          commit("setValues", values);
        });
    },
    pushValue({commit}, value) {
      let data = serialize(BranchModel, value);
      return firebase.database()
        .ref("/branches/" + value.uid)
        .set(data, error => {
          if (error) {
            console.error("push failed: " + error);
          } else {
            commit("updateValue", value);
          }
        });
    },
    removeValue({commit}, uid) {
      return firebase.database()
        .ref("/branches/" + uid)
        .set(null, error => {
          if (error) {
            console.error("remove failed: " + error);
          } else {
            console.error("remove succeeded: " + uid);
            commit("removeValue", uid);
          }
        });
    },
  }
}